module.exports = __webpack_public_path__ + "static/img/team_member_leon.35cf8408.png";